import React from 'react'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'

import Tooltip from 'components/Tooltip'

type Props = {
  severity: string,
  size?: string,
  title?: string,
  className?: string
}
const AlertIcon = ({ severity, size = '18px', title = '', className } : Props) => {
  return (
    <Tooltip title={title || ''} placement="top">
      <S.Container readOnly enabled={!!title}>
        <S.AlertIcon
          role="img"
          aria-label={`${severity} alert`}
          className={`icon-${severity}-alert` + (className ? ` ${className}` : '')}
          size={size}
        />
      </S.Container>
    </Tooltip>
  )
}

export default AlertIcon

const S = {
  Container: styled(KeyboardAccessible)`
    display: inline-block;
  `,
  AlertIcon: styled.span.withConfig({
    shouldForwardProp: (prop) => !['size'].includes(prop)
  })<{ size }>`
    font-size: ${({ size }) => size};
  `
}
